import "../../css/home/loading.css";

const Loading = () => {
  return (
    <div className="body">
      <div className="ContainerLoading">
        <span className="loader">SOMO</span>
        <span className="loadAnime1"></span>
        <span className="loadAnime2"></span>
      </div>
    </div>
  );
};

export default Loading;
